import { PresentationChartIcon } from '@phosphor-icons/react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
// fallow-ignore-next-line circular-dependency -- co-located route modules must import the pathless parent; the cycle is EntityQuickFind → routeTree → routes.tsx → this module → route.tsx and already exists for every migrated route.
import { Route as pathlessAuthenticatedRoute, requireAdmin } from '../route';

const AiUsagePage = lazyRouteComponent(
  () => import('./AiUsagePage'),
  'AiUsagePage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/ai-usage',
  staticData: {
    app: {
      nav: {
        label: 'AI Cost',
        icon: <PresentationChartIcon className="h-4 w-4" weight="fill" />,
        group: 'Admin',
        order: 80,
      },
      access: {
        adminOnly: true,
      },
    },
  },
  component: AiUsagePage,
  loader: () => ({
    crumb: 'AI Cost',
  }),
  beforeLoad: ({ context }) => {
    requireAdmin({ context });
  },
});
